export default __webpack_public_path__ + "static/media/logo@3x.4cd11008.png";